<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>
<script>
// 引入基本模板
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
// 引入提示框和title组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");

export default {
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "270px",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.initChart();
    // });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart(data) {
      var _data = data.map((x) => x.Value);
      // 给名称添加唯一索引，避免ECharts自动去重
      var _names = data.map((x, index) => `${x.Name}__idx_${index}`);

      this.chart = echarts.init(this.$el, "macarons");
      let option = {
        grid: {
            left: '3%',
            right: '2%',
            top: '10%',
            bottom: '1%',
            containLabel: true
        },
        xAxis: {
          type: "category",
          data: _names,
          splitLine: { show: false },  // 隐藏x轴网格线
          axisLabel: {
            color: "#000",
            formatter: function(value) {
              // 从标签中移除索引后缀，只显示原始名称
              return value.replace(/__idx_\d+$/, '');
            }
          },
        },
        yAxis: {
          type: "value",
          splitLine: { show: false },  // 隐藏y轴网格线
          axisLabel: {
            color: "#000"
          },
        },
        color: ["#409eff"],
        series: [
          {
            name: "",
            type: "bar",
            data: _data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            barMaxWidth: 50,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  position: "top",
                  textStyle: {
                    align: "center",
                    fontFamily: "微软雅黑",
                    fontSize: 12,
                    color: "#303133",
                    // fontWeight: "bolder"
                  },
                },
                // labelLine: {
                //   show: true,
                //   length: 3
                // }
              },
            },
          },
        ],
      };
      this.chart.setOption(option);
    },
    handleResize() {
      if(this.chart) this.chart.resize();
    },
  },
};
</script>